export default __webpack_public_path__ + "static/media/recovery_icon.7029541e.svg";